<template>
  <div>
    <v-card class="pa-2" color="grey lighten-3">
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="cuadre.detalles"
            :items-per-page="-1"
            class="pb-1"
            dense
            disable-sort
            hide-default-footer
            style="border: 1px solid #757575; border-radius: 10px"
            item-key="indx"
            id="TbBord"
          >

             <template v-slot:item.tipo="props">
              <span style="display:none;">{{ props.item.indx = cuadre.detalles.indexOf(props.item) }}</span>
              <span style="font-size:13px;"><b>{{ props.item.tipo.descripcion }}</b></span>
             </template>

            <!-- <template #item.tipo="{ item }">
              {{ item.tipo.descripcion }}
            </template> -->

            <template #item.asignaciones="{ item }">
              <vue-autonumeric
                v-model.number="item.asignaciones"
                :an-options="{ decimalPlaces: 3, minimumValue: 0, emptyInputBehavior: 0 }"
                class="align-center"
                dense
                hide-details
                outlined
              ></vue-autonumeric>
            </template>

            <template #item.donaciones="{ item }">
              <vue-autonumeric
                v-model.number="item.donaciones"
                :an-options="{ decimalPlaces: 3, minimumValue: 0, emptyInputBehavior: 0 }"
                class="align-center"
                dense
                hide-details
                outlined
              ></vue-autonumeric>
            </template>

            <template #item.prueba="{ item }">
              <vue-autonumeric
                v-model.number="item.prueba"
                :an-options="{ decimalPlaces: 3, minimumValue: 0, emptyInputBehavior: 0 }"
                class="align-center"
                dense
                hide-details
                outlined
              ></vue-autonumeric>
            </template>

            <!-- <template #item.inventarioInicial="{ item }">
              <vue-autonumeric
                v-model.number="item.inventarioInicial"
                :an-options="{ decimalPlaces: 3 }"
                class="align-center"
                dense
                hide-details
                outlined
                readonly
              ></vue-autonumeric>
            </template> -->

              <template v-slot:item.inventarioInicial="props">
              <!-- <span style="font-size:13px;"><b>{{ props.item.inventarioInicial }}</b></span> -->
           <AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="props.item.inventarioInicial"
                                                     :label="``" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     dense hide-details
                                                     outlined style="font-size: 13px;"
                                                     v-bind:options="{ 'decimalPlaces': 3}">
                        </AutoNumericNuevoWithOptions>
           
            </template>


            <template #item.compras="{ item }">
              <vue-autonumeric
                v-model.number="item.compras"
                :an-options="{ decimalPlaces: 3, minimumValue: 0, emptyInputBehavior: 0 }"
                class="align-center"
                dense
                hide-details
                outlined
                @change="updateExistenciaLibro(item)"
              ></vue-autonumeric>
            </template>

            <template #item.salidas="{ item }">
              <vue-autonumeric
                v-model.number="item.salidas"
                :an-options="{ decimalPlaces: 3, minimumValue: 0, emptyInputBehavior: 0 }"
                class="align-center"
                dense
                hide-details
                outlined
                @change="updateExistenciaLibro(item)"
              ></vue-autonumeric>
            </template>

            <template #item.existenciaLibro="{ item }">
              <vue-autonumeric
                v-model.number="item.existenciaLibro"
                :an-options="{ decimalPlaces: 3 }"
                class="align-center"
                dense
                hide-details
                outlined
                readonly
              ></vue-autonumeric>
            </template>

            <template #item.inventarioFinal="{ item }">
              <vue-autonumeric
                v-model.number="item.inventarioFinal"
                :an-options="{ decimalPlaces: 3, minimumValue: 0, emptyInputBehavior: 0 }"
                class="align-center"
                dense
                hide-details
                outlined
                @change="updateInventarioFinal(item)"
              ></vue-autonumeric>
            </template>

            <template #item.diferencia="{ item }">
              <vue-autonumeric
                v-model.number="item.diferencia"
                :an-options="{ decimalPlaces: 3 }"
                class="align-center"
                dense
                hide-details
                outlined
                readonly
              ></vue-autonumeric>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  import VueAutonumeric from "../../components/AutoNumericNuevo"
import AutoNumericNuevoWithOptions from "../../components/AutoNumericNuevoWithOptions.vue"
  export default {
    components: {
      VueAutonumeric,
      AutoNumericNuevoWithOptions
    },

    data() {
      return {
        headers: [
          { text: "Tipo", value: "tipo", width: "auto",class: ['no-gutters black--text'] },
          { text: "Asignaciones", value: "asignaciones", width: "auto",class: ['no-gutters black--text'] },
          { text: "Donaciones", value: "donaciones", width: "auto",class: ['no-gutters black--text'] },
          { text: "Pruebas", value: "prueba", width: "auto",class: ['no-gutters black--text'] },
          { text: "Inventario Inicial", value: "inventarioInicial", width: "auto",class: ['no-gutters black--text'] },
          { text: "Compras", value: "compras", width: "auto",class: ['no-gutters black--text'] },
          { text: "Salidas", value: "salidas", width: "auto",class: ['no-gutters black--text'] },
          { text: "Existencia Libros", value: "existenciaLibro", width: "auto",class: ['no-gutters black--text'] },
          { text: "Inventario Fisico Final", value: "inventarioFinal", width: "auto",class: ['no-gutters black--text'] },
          { text: "Diferencia", value: "diferencia", width: "auto",class: ['no-gutters black--text'] },
        ],
      }
    },

    props: {
      cuadre: {
        type: Object,
        required: true,
      },
    },

    methods: {
      updateExistenciaLibro(item) {
        item.existenciaLibro = item.inventarioInicial + item.compras - item.salidas
       // item.diferencia = Math.abs(item.inventarioFinal - item.existenciaLibro)
       item.diferencia = item.inventarioFinal - item.existenciaLibro
      },

      updateInventarioFinal(item) {
       // item.diferencia = Math.abs(item.inventarioFinal - item.existenciaLibro)
       // item.diferencia = item.inventarioFinal - item.existenciaLibro
      },
    },

    computed: {},

    watch: {
      "cuadre.detalles": {
        handler(val) {
          val.forEach((item) => {
            item.existenciaLibro = item.inventarioInicial + item.compras - item.salidas
            //item.diferencia = Math.abs(item.inventarioFinal - item.existenciaLibro)
            item.diferencia = item.inventarioFinal - item.existenciaLibro
          })
        },
        deep: true,
      },
    },
  }
</script>

<style scoped></style>
